const ResetIcon: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.27246 12C3.27246 7.18004 7.17979 3.27271 11.9997 3.27271C16.8197 3.27271 20.727 7.18004 20.727 12C20.727 16.8199 16.8197 20.7272 11.9997 20.7272C7.17979 20.7272 3.27246 16.8199 3.27246 12Z"
        fill="#777777"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8893 8.11009C16.2301 8.45089 16.2301 9.00347 15.8893 9.34431L13.2339 11.9999L15.8898 14.6555C16.2306 14.9963 16.2306 15.5489 15.8898 15.8897C15.549 16.2306 14.9964 16.2306 14.6556 15.8898L11.9998 13.2342L9.34435 15.8898C9.00355 16.2306 8.45096 16.2306 8.11013 15.8898C7.7693 15.549 7.76928 14.9964 8.11009 14.6556L10.7655 12L8.11015 9.3448C7.76931 9.004 7.76929 8.45141 8.1101 8.11058C8.45091 7.76975 9.00349 7.76973 9.34433 8.11054L11.9997 10.7657L14.6551 8.11013C14.9959 7.7693 15.5484 7.76928 15.8893 8.11009Z"
        fill="white"
      />
    </svg>
  );
};

export default ResetIcon;
